import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const NotiPermissionResquest = {
  getNotiPermissionContent: () =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/noti-permission`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  updateNotiPermissionContent: data =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/noti-permission`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),
}
